import { useApi } from '../../api/api-context';
import { useQueryMutation } from '../../api/use-query-mutation';
import { useBudgetId } from '../../budget/budget-store';
import { logAndThrowError } from '../../utils/errors';
export const useSortAccountsApi = (options) => {
    const api = useApi();
    const budgetId = useBudgetId();
    const queryKey = ['accounts', budgetId];
    // api call
    const sortAccountsApi = async (data) => {
        await api.post('/account/sort', data);
    };
    // optimistic update
    const onMutate = (oldData, request) => {
        if (!oldData) {
            logAndThrowError('No accounts data found');
        }
        // create a map of id to account for quick lookup
        const accountMap = new Map(oldData.map((account) => [account.id, account]));
        // create new sorted array based on the request ids
        return request.ids.map((id, index) => {
            const account = accountMap.get(id);
            if (!account) {
                logAndThrowError(`Account with id ${id} not found`);
            }
            return { ...account, position: index };
        });
    };
    return useQueryMutation(sortAccountsApi, queryKey, onMutate, options);
};
